import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BusinessList = _resolveComponent("BusinessList")!

  return (_openBlock(), _createBlock(_component_BusinessList, {
    tabPanelData: _ctx.tabList,
    statusIn: 4,
    marketFeeCanCommand: false,
    FilterFieldProps: _ctx.FilterField,
    approvalParams: {
      receivedStatus: 3
    },
    showSummary: true,
    businessTypeName: "TABLE_RECEIVED_DONE_BUSINESS",
    pageTypeIn: "RECEIVED_DONE",
    summaryField: []
  }, null, 8, ["tabPanelData", "FilterFieldProps"]))
}